import { render, staticRenderFns } from "./MultiView.vue?vue&type=template&id=58650ddf"
import script from "./MultiView.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MultiView.vue?vue&type=style&index=0&id=58650ddf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QPagination,QInnerLoading});
